export default __webpack_public_path__ + "media/images/carnival/header_1920x1080_rj-69f000e461f6eb966ef53e74778bf2dc.jpg";